import React, { useEffect, useRef } from 'react';

/**
 * Prompt the user for confirmation before unloading the page.
 * This only comes in effect when the user navigate out of the app.
 */

const UnloadPrompt: React.FC = ({ children }) => {
  const ref = useRef<OnBeforeUnloadEventHandler>(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const callback = (event: Event): string => {
      event.preventDefault();

      // Required by Chrome
      // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
      event.returnValue = true;

      // The message _might_ be used by IE. It's not used by Chrome and Firefox.
      return 'You will lose all progress if you leave.';
    };

    window.addEventListener('beforeunload', callback);
    ref.current = callback;

    return () => {
      ref.current && window.removeEventListener('beforeunload', ref.current);
    };
  }, []);

  return <React.Fragment>{children}</React.Fragment>;
};

export default UnloadPrompt;
